import moment from "moment";
import { select_access_token } from "./TokenConn";
import { Fn_activeAxios } from "../function/FnConfig";
import salesStore from "../stores/SalesStore";
import { posBridge } from "function/FnPosBridge"
import { fn_getDetailButtonView, fn_initTotalVal } from "function/FnBodySales"

// 상품별 매출 목록 조회
export function api_product_sales_list(rootStore) {
    const searchStore = rootStore.searchStore;
    const salesStore = rootStore.salesStore;

    let startVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.start_val : new Date();
    let endVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.end_val : new Date();
    let hookingChannelAllYn = ""

    if (fn_getDetailButtonView(rootStore).all == true) {
        hookingChannelAllYn = "Y"
    } else {
        hookingChannelAllYn = "N"
    }

    let data = JSON.stringify(
        {
            ...searchStore.getShopCdSaleDate,
            pageNo: salesStore.getSalesPaging.sales_page_no,  // 현재 페이지
            productPriceType: salesStore.getPriceTypeVal.productPriceType,  //가격유형
            productType: salesStore.getProductTypeVal.productType,       //상품유형
            productName: salesStore.getProductNameSearchVal,
            saleBasis: "O",
            shopCd: searchStore.getShopCd,
            startDate: moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            endDate: moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            hookingChannelAllYn: hookingChannelAllYn,   //주문채널전체
            isNormalSearch: "Y",
            channels: salesStore.getDetailButtonView,
            orderByReq: {
                orderByProductName: salesStore.getSortTypeVal.orderByProductName.status,
                orderBySaleAmount: salesStore.getSortTypeVal.orderBySaleAmount.status,
                orderBySaleVolume: salesStore.getSortTypeVal.orderBySaleVolume.status,
                viewType: salesStore.getSortTypeVal.viewType
            }
        }
    )
    salesStore.setSalesProductExcelSearchList(data);
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/hooking/statics/products', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    fn_initTotalVal(rootStore);
                    salesStore.setSalesPagingInfo("sales_max_page", 1)
                    const data = res.data.data;
                    if (data.eachProductInfoList && data.eachProductInfoList.length != 0) {
                        salesStore.setSalesProductList(data.eachProductInfoList);
                        salesStore.setTotalSalesVal("totalSaleAmount", data.totalSaleAmount);
                        salesStore.setTotalSalesVal("totalSaleCount", data.totalSaleCount);
                        salesStore.setSalesPagingInfo("sales_max_page", data.maxPage)
                    }
                    salesStore.setAfterDetailUpdate();
                    salesStore.setSalesProductList(data.eachProductInfoList);

                }
            }
        }).catch(err => {
        });
}

// 상품별 매출 상세 조회
export function api_product_sales_detail(rootStore, productName) {
    const searchStore = rootStore.searchStore;
    const salesStore = rootStore.salesStore;

    let startVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.start_val : new Date();
    let endVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.end_val : new Date();
    let data = JSON.stringify(
        {
            ...searchStore.getShopCdSaleDate,
            productName: productName,
            saleBasis: "O",
            shopCd: searchStore.getShopCd,
            //shopCd: "K20773",
            startDate: moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            endDate: moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            isNormalSearch: "Y",
        }
    )
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/hooking/statics/products/detail', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    const data = res.data.data;
                    salesStore.setSalesProductDetail(data);
                }
            }
        }).catch(err => {
        });
}

// 누락 상품 조회 목록
export function api_product_sales_etc_list(rootStore) {
    const salesStore = rootStore.salesStore;
    const searchStore = rootStore.searchStore;
    let startVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.start_val : new Date();
    let endVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.end_val : new Date();
    let data = JSON.stringify(
        {
            shopCd: searchStore.getShopCd,
            startDate: moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            endDate: moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            isNormalSearch: "N",
            pageNo: salesStore.getSalesEtcPaging.sales_page_no,  // 현재 페이지
        }
    )
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/hooking/statics/products/fail', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    const data = res.data.data;
                    salesStore.setSalesEtcPagingInfo("sales_max_page", 1)
                    if (data.failedProductList) {
                        salesStore.setSalesProductEtcList(data.failedProductList);
                        salesStore.setSalesEtcPagingInfo("sales_max_page", data.maxPage)
                    }
                }
            }
        }).catch(err => {
        });
}

// 상품별 매출 엑셀다운 목록
export function api_product_sales_excel_list(rootStore) {
    const salesStore = rootStore.salesStore;
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/hooking/statics/products/excel', salesStore.getSalesProductExcelSearchList, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                let url = rootStore.settingStore.ActiveRestUrl.okgoApi + "/gate/public/hooking/statics/products/excel?token="
                let ret = posBridge(rootStore, '{"command" : "URL_POPUP", "link" :"' + url + res.data.data + '" }', 'POPUP');
            }
        }).catch(err => {
        });
}


// 시간대별 매출 엑셀다운 목록
export function api_time_sales_excel_list(rootStore) {
    const searchStore = rootStore.searchStore;
    let startVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.start_val : new Date();
    let endVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.end_val : new Date();
    let data = JSON.stringify(
        {
            ...searchStore.getShopCdSaleDate,
            shopCd: searchStore.getShopCd,
            //shopCd: "V09633",
            startDate: moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            endDate: moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD")
        }
    )
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/hourly-sales/excel', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                let url = rootStore.settingStore.ActiveRestUrl.okgoApi + "/gate/public/hourly-sales/excel?token="
                let ret = posBridge(rootStore, '{"command" : "URL_POPUP", "link" :"' + url + res.data.data + '" }', 'POPUP');
            }
        }).catch(err => {
        });
}

// 재조회
export function api_product_sales_reload(rootStore) {
    const salesStore = rootStore.salesStore;
    const api = Fn_activeAxios(rootStore);

    api.post('/gate/okgo/hooking/statics/products', salesStore.getSalesProductExcelSearchList, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    fn_initTotalVal(rootStore);
                    const data = res.data.data;
                    if (data.eachProductInfoList && data.eachProductInfoList.length != 0) {
                        salesStore.setSalesProductList(data.eachProductInfoList);
                        salesStore.setTotalSalesVal("totalSaleAmount", data.totalSaleAmount);
                        salesStore.setTotalSalesVal("totalSaleCount", data.totalSaleCount);
                        salesStore.setSalesPagingInfo("sales_max_page", data.maxPage)
                    }
                    salesStore.setAfterDetailUpdate();
                    salesStore.setSalesProductList(data.eachProductInfoList);

                }
            }
        }).catch(err => {
        });
}

// 매출캘린더
export function api_calendar_sales(rootStore) {
    const salesStore = rootStore.salesStore;
    const api = Fn_activeAxios(rootStore);
    let data = [

    ]
    salesStore.setSalesCalendarList(data);
}

// 상품별 매출내역 리스트
export function product_sales_list(rootStore) {
    select_access_token(rootStore).then(res => {
        api_product_sales_list(rootStore);
    });
}

// 상품별 매출내역 재조회
export function product_sales_reload_list(rootStore) {
    select_access_token(rootStore).then(res => {
        api_product_sales_reload(rootStore);
    });
}

// 상품별 매출내역 상세보기
export function product_sales_detail_list(rootStore, productName) {
    select_access_token(rootStore).then(res => {
        api_product_sales_detail(rootStore, productName);
    });
}

// 누락상품 매출내역 리스트
export function product_sales_etc_list(rootStore) {
    select_access_token(rootStore).then(res => {
        api_product_sales_etc_list(rootStore);
    });
}

// 판매상품 매출내역 엑셀다운 리스트
export function product_sales_excel_list(rootStore) {
    select_access_token(rootStore).then(res => {
        api_product_sales_excel_list(rootStore);
    });
}

// 시간대 매출내역 엑셀다운 리스트
export function time_sales_excel_list(rootStore) {
    select_access_token(rootStore).then(res => {
        api_time_sales_excel_list(rootStore);
    });
}


// 시간대별 매출 목록 조회
export function api_time_sales_list(rootStore) {
    const searchStore = rootStore.searchStore;
    const salesStore = rootStore.salesStore;

    let startVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.start_val : new Date();
    let endVal = salesStore.getSalesDateVal.start_val ? salesStore.getSalesDateVal.end_val : new Date();

    let data = JSON.stringify(
        {
            ...searchStore.getShopCdSaleDate,
            shopCd: searchStore.getShopCd,
            //shopCd: "V09633",
            startDate: moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
            endDate: moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD")
        }
    )
    //salesStore.setSalesProductExcelSearchList(data);
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/hourly-sales', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    const data = res.data.data;
                    salesStore.setSalesTimeRank(data.rank);
                    salesStore.setSalesTimeList(data.hourlySales);
                    salesStore.setTotalSalesTimeVal("totalSales", data.totalSales);
                    salesStore.setTotalSalesTimeVal("totalCount", data.totalCount);

                }
            }
        }).catch(err => {
        });
}

// 시간대별 매출내역 리스트
export function time_sales_list(rootStore) {
    select_access_token(rootStore).then(res => {
        api_time_sales_list(rootStore);
    });
}